import React from "react";
import Style from "../../style/travelbanner.module.scss";
import TravelQuoteForm from "./Form/TravelForm";

const TravelBanner = () => {
  return (
    <div className={Style.content}>
      <div className={Style.wrapper}>
        <div className={Style.left}>
          <h2>Your Gateway to India: Discover Exclusive Airfare Deals Today</h2>
          <p>
            Get the best deals on international flights. Trusted travel agents
            with exclusive offers and discounts for you.
          </p>
        </div>
        <div className={Style.right}>
          <TravelQuoteForm />
        </div>
      </div>
    </div>
  );
};

export default TravelBanner;
